import { ItemTypes } from 'app/shared/models/orders-and-billing/enums/item-types';
export class ItemBasicInfo {
    Id: number = 0;
    Code: string = "";
    Title: string = "";
    ForeignTitle: string = "";
    Type: ItemTypes;
    DefaultUnitGroupId?: number;
    MedicationProductId: number;
    MedicationDefinitionId?: number;
    ItemType?: number;
}
